<template>
  <div class="mcontainer">
    <!-- Header -->
    <div class="header-bar">
      <div class="title">
        <h2>Connect Alumni</h2>
        <p class="subtitle">Jelajahi alumni berdasarkan jurusan</p>
      </div>

      <div class="actions">
        <!-- Filter Faculty -->
        <select
          class="form-control"
          v-model="faculty"
          @change="fetchAlumni"
        >
          <option value="">Semua Jurusan</option>
          <option v-for="f in faculties" :key="f" :value="f">
            {{ f }}
          </option>
        </select>

        <!-- Search -->
        <input
          type="text"
          class="search-input"
          placeholder="Cari nama atau email..."
          v-model="search"
          @input="onSearch"
        />
      </div>
    </div>

    <!-- Card -->
    <div class="card">
      <!-- Loading -->
      <div v-if="loading" class="loading-wrap">
        Loading...
      </div>

      <!-- Empty -->
      <div v-else-if="alumni.length === 0" class="empty-state">
        <Icon icon="mdi:account-search-outline" width="22" height="22" />
        <span>Tidak ada alumni ditemukan</span>
      </div>

      <!-- List -->
      <div v-else class="grid">
        <div
          v-for="user in alumni"
          :key="user.id"
          class="user-card"
        >
          <div class="avatar">
            {{ user.fullname.charAt(0).toUpperCase() }}
          </div>

          <div class="user-info">
            <div class="name">{{ user.fullname }}</div>
            <div class="email">{{ user.email }}</div>
            <span class="badge" v-if="user.faculity">
              {{ user.faculity }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Icon } from "@iconify/vue2";

let debounceTimer = null;

export default {
  name: "Connect",
  components: { Icon },

  data() {
    return {
      alumni: [],
      faculty: "",
      search: "",
      loading: false,

      faculties: [],
      authFaculty: ""
    };
  },

  mounted() {
    this.setAuthFaculty();
    this.fetchAlumni();
  },

  methods: {
    setAuthFaculty() {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user && user.faculity) {
        this.authFaculty = user.faculity;
        this.faculty = user.faculity;
      }
    },

    async fetchAlumni() {
      this.loading = true;
      try {
        const params = new URLSearchParams();
        params.set("type", "alumni");

        if (this.faculty) params.set("faculity", this.faculty);
        if (this.search) params.set("search", this.search);

        const res = await axios.get(
          `user/all?${params.toString()}`
        );

        const data = res?.data?.data || [];
        this.alumni = data;

        // generate faculties dinamis
        const facSet = new Set();
        data.forEach(u => {
          if (u.faculity) facSet.add(u.faculity);
        });
        this.faculties = Array.from(facSet).sort();
      } catch (e) {
        console.error("Fetch alumni error", e);
        this.alumni = [];
      } finally {
        this.loading = false;
      }
    },

    onSearch() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        this.fetchAlumni();
      }, 400);
    }
  }
};
</script>

<style scoped>
/* Header */
.header-bar {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 16px;
}
.title h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}
.subtitle {
  margin: 4px 0 0;
  font-size: 13px;
  color: #6b7280;
}
.actions {
  display: flex;
  gap: 10px;
}

/* Inputs */
.form-control,
.search-input {
  height: 38px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 0 12px;
  font-size: 14px;
}

/* Card */
.card {
  background: #fff;
  border: 1px solid #eef2f7;
  border-radius: 14px;
  padding: 16px;
}

/* Grid */
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 12px;
}

/* User card */
.user-card {
  display: flex;
  gap: 12px;
  padding: 14px;
  border-radius: 12px;
  border: 1px solid #eef2f7;
  background: #fafafa;
}
.avatar {
  height: 44px;
  width: 44px;
  border-radius: 50%;
  background: #2563eb;
  color: #fff;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user-info {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 4px;
}
.name {
  font-weight: 600;
}
.email {
  font-size: 13px;
  color: #6b7280;
}
.badge {
  display: inline-block;
  margin-top: 4px;
  font-size: 12px;
  padding: 5px 15px;
  border-radius: 9999px;
  background: #ecfdf5;
  color: #065f46;
}

/* States */
.loading-wrap {
  display: flex;
  justify-content: center;
  color: #6b7280;
}
.empty-state {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #9ca3af;
}

/* Responsive */
@media (max-width: 768px) {
  .header-bar {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .actions {
    width: 100%;
    flex-direction: column;
  }
}
</style>
